var RowContainerAlign = /* @__PURE__ */ ((RowContainerAlign2) => {
  RowContainerAlign2["START"] = "start";
  RowContainerAlign2["END"] = "end";
  RowContainerAlign2["CENTER"] = "center";
  RowContainerAlign2["BETWEEN"] = "between";
  RowContainerAlign2["AROUND"] = "around";
  RowContainerAlign2["EVENLY"] = "evenly";
  return RowContainerAlign2;
})(RowContainerAlign || {});

export { RowContainerAlign };
//# sourceMappingURL=row-container-align.enum.js.map
